import React from 'react';
import PrivateRoute from 'PrivateRoutes';
const HelpCenterFolder = React.lazy(() => import(/* webpackChunkName: "HelpCenterFolder" */'./components'));
const routes = () => [
    <PrivateRoute
        key="/settings/help-center/folder/:_id"
        exact
        path="/settings/help-center/folder/:_id"
        component={({ location, match }) => {
            console.log('location', location)
            const helpCenterId = location.state ? location.state.helpCenterId : ""
            return <HelpCenterFolder parentId={match.params._id} helpCenterId={helpCenterId} />;
        }}
    />
];

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/HelpCenterFolder/routes.js